<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Gömrük kalkulyatoru</h1>
        <p>
          Azərbaycan Respublikası ərazisinə idxal edilən minik nəqliyyat
          vasitələrinə şamil olunan gömrük ödənişlərinin hesablanması qaydaları
        </p>
      </div>

      <div class="col-md-6">
        <h2>Nəqliyyat vasitəsinin məlumatları</h2>

        <p>Nəqliyyat vasitəsinin növü</p>
        <input type="text" value="Minik avtomobili" disabled />
        <!-- <input type="number" v-model="autoType" /> -->

        <div class="row">
          <div class="col-md-6">
            <p>Mühərrikin növü</p>
            <select v-model="engineType">
              <option value="0">Benzin</option>
              <option value="1">Dizel</option>
              <option value="2">Qaz</option>
              <option value="3">Hibrid-benzin</option>
              <option value="4">Hibrid-dizel</option>
              <option value="5">Elektrik</option>
            </select>
          </div>
          <div class="col-md-6">
            <p>Mühərrikin həcmi (sm<sup>3</sup>)</p>
            <input type="number" min="0" v-model="engine" />
          </div>
        </div>

        <p>İstehsal tarixi</p>
        <!-- <input type="date" v-model="issueDate" /> -->
        <div class="row">
          <div class="col-6">
            <select v-model="month">
              <option value="" disabled>Ay</option>
              <option
                :value="('0' + (i + 1)).slice(-2)"
                v-for="(m, i) in months"
                :key="m"
              >
                {{ m }}
              </option>
            </select>
          </div>
          <div class="col-6">
            <select v-model="year">
              <option value="" disabled>İl</option>
              <option :value="y" v-for="y in years" :key="y">{{ y }}</option>
            </select>
          </div>
        </div>

        <p>
          Gömrük dəyəri (İnvoys dəyəri + Nəqliyyat xərci + Digər xərclər, USD)
        </p>
        <input type="number" min="0" v-model="price" />

        <p>Mənşə (istehsal) ölkəsi və göndərən ölkə haqqında</p>
        <select v-model="commerceType">
          <option value="0">Digər ölkələr</option>
          <option value="1">
            Azad ticarət sazişi bağlanan ölkədə istehsal olunub və oradan
            gətirilir
          </option>
        </select>

        <button @click="calc">Hesabla</button>
        <button @click="clear">Təmizlə</button>
      </div>
      <div class="col-md-6">
        <h2>Nəticə</h2>

        <div class="note" v-if="Object.hasOwn(data, 'autoDuty')">
          <h3>
            {{ data.autoDuty.total.name }}: {{ data.autoDuty.total.value }} AZN
          </h3>

          <ul>
            <li v-for="d in data.autoDuty.duties" :key="d.code">
              {{ d.name }}: <strong>{{ d.value }} AZN</strong>
            </li>
          </ul>

          <p>
            Diqqət! Gömrük ödənişləri daxil edilmiş məlumatlar əsasında
            hesablanmışdır. Gömrük rəsmiləşdirilməsi zamanı malların gömrük
            dəyərinin müəyyənləşdirilməsi üsulundan asılı olaraq cəmi gömrük
            ödənişlərində fərqlər yarana bilər.
          </p>
          <p>
            <a
              href="https://customs.gov.az/az/ferdler-ucun/avtomobillerin-getirilmesi"
              target="_blank"
            >
              Hesablama qaydası və digər məlumatlar
            </a>
          </p>
        </div>

        <div class="note" v-else>
          <p>Zəhmət olmasa məlumatları daxil edin</p>
        </div>

        <div class="col-12" v-if="loading">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      autoType: 0,
      engineType: 0,
      price: 0,
      engine: 0,
      issueDate: "",
      commerceType: 0,

      data: {},

      month: "",
      year: "",

      loading: false,
    };
  },
  computed: {
    years: function () {
      let currentYear = new Date().getFullYear();
      return [...Array(11).keys()].map((x) => x + currentYear - 10);
    },
    months: function () {
      return [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "İyun",
        "İyul",
        "Avqust",
        "Sentyabr",
        "Oktyabr",
        "Noyabr",
        "Dekabr",
      ];
    },
  },
  methods: {
    calc: function () {
      this.loading = true;
      axios
        .post(
          "https://c2b-fbusiness.customs.gov.az/api/v1/dictionaries/calAutoDuty",
          {
            commerceType: this.commerceType,
            autoType: this.autoType,
            engineType: this.engineType,
            price: this.price,
            engine: this.engine,
            issueDate: `01.${this.month}.${this.year}`,
          }
        )
        .then((response) => {
          this.data = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    clear: function () {
      console.log("clear...");
      this.autoType = 0;
      this.engineType = 0;
      this.price = 0;
      this.engine = 0;
      this.month = "";
      this.year = "";
      this.commerceType = 0;
      this.data = {};
    },
  },
};
</script>

<style scoped>
.checkbox-wrapper {
  display: block;
  position: relative;
  padding-left: 2rem;
  margin-right: 1rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox-wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox-wrapper .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #ccc;
  border-radius: 100%;
}
.checkbox-wrapper:hover input ~ .checkmark {
  background-color: #ccc;
}
.checkbox-wrapper input:checked ~ .checkmark {
  background-color: #003366;
}
button {
  margin-top: 1rem;
  margin-right: 1rem;
  background: #003366;
  color: #fff;
}
ul {
  padding: 0;
  list-style-type: none;
}
ul > li {
  border-bottom: 1px solid #ddd;
  padding: 0.5rem 0;
  font-size: 13px;
}
h3 {
  color: #003366;
  width: fit-content;
  border-bottom: 2px solid #003366;
  font-size: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/calc/Customs.vue